import RedirectWithParams from 'components/Common/RedirectWithParams'
import React, { Component, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { COUNTRY_CODE_INDONESIA } from 'constants/dynamicFieldConstants'

// routes config
import routes from '../../routes'

import { isMobile, isWebView } from '../../utils/common'
// Components
import { loading } from '../../components/Common/Loading'
const DefaultHeader = React.lazy(() => import('./DefaultHeader'))

/**
 * @class DefaultLayout
 */
class DefaultLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    // Should block access to Driver Onboarding if accessed NOT from Driver App (ID only)
    const verifyCountry = JSON.parse(window.localStorage.getItem('dlvr_verifyCountry'))
    const countryCode = verifyCountry.country_code
    if (countryCode === COUNTRY_CODE_INDONESIA) {
      // desktop and mobile browser
      if (!isMobile.any() || (isMobile.any() && !isWebView())) {
         window._$g.rdr('404')
      }
    }
  }

  render() {
    const verifyCountry = JSON.parse(window.localStorage.getItem('dlvr_verifyCountry'))
    const isTransportify = verifyCountry.isTransportify === true
    const country = isTransportify ? '' : `/${verifyCountry.country_code}`

    return (
      <React.Fragment>
        {!isMobile.any() && <DefaultHeader />}
        <Suspense fallback={loading()}>
          <Switch>
            {/* NOTES:
                 - Confirmation page is removed but the URL is still be used in driver app.
                   So we should support them by redirect from Confirmation page to Complete Application page
            */}
            <RedirectWithParams
              from={isTransportify ? '/confirmation_page' : `${country}/confirmation_page`}
              to={isTransportify ? '/complete_application' : `${country}/complete_application`}
            />


            {/* 
              NOTES: Why we have these redirects
              SMS Provider doesn't support underscore on the URL. 
              So we need to use non-underscore URLs in SMS, and create redirects here to back to our regular URls.
           */}
            <RedirectWithParams
              from={isTransportify ? '/signin' : `${country}/signin`}
              to={isTransportify ? '/sign_in' : `${country}/sign_in`}
            />
            <RedirectWithParams
              from={isTransportify ? '/signup' : `${country}/signup`}
              to={isTransportify ? '/sign_up' : `${country}/sign_up`}
            />

            <RedirectWithParams
              from={isTransportify ? '/etraining/:driverId' : `${country}/etraining/:driverId`}
              to={isTransportify ? '/e_training/:driverId' : `${country}/e_training/:driverId`}
            />

            <RedirectWithParams
              from={isTransportify ? '/etrainingsignin/:driverId' : `${country}/etrainingsignin/:driverId`}
              to={isTransportify ? '/etraining_signin/:driverId' : `${country}/etraining_signin/:driverId`}
            />

            {routes.map((route, idx) => {
              return route.component ? (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  component={route.component} />
              ) : (null)
            })}
            <Redirect from="/" to={`${country}/404`} />
          </Switch>
        </Suspense>
      </React.Fragment>
    )
  }
}

export default DefaultLayout
